import { withInstall, withNoopInstall } from '@bigin/utils'

import Chart from './src/index.vue'
import BarChart from './src/bar-chart.vue'
import LineChart from './src/line-chart.vue'
import BubbleChart from './src/bubble-chart.vue'
import PieChart from './src/pie-chart.vue'
import PolarAreaChart from './src/polar-area-chart.vue'
import DonutChart from './src/donut-chart.vue'
import RadarChart from './src/radar-chart.vue'
import ScatterChart from './src/scatter-chart.vue'
import * as Utils from './src/utils'

export const BChart = withInstall(Chart, {
  BarChart,
  LineChart,
  BubbleChart,
  PieChart,
  PolarAreaChart,
  DonutChart,
  RadarChart,
  ScatterChart,
})

export default BChart
export const BBarChart = withNoopInstall(BarChart)
export const BLineChart = withNoopInstall(LineChart)
export const BBubbleChart = withNoopInstall(BubbleChart)
export const BPieChart = withNoopInstall(PieChart)
export const BPolarAreaChart = withNoopInstall(PolarAreaChart)
export const BDonutChart = withNoopInstall(DonutChart)
export const BRadarChart = withNoopInstall(RadarChart)
export const BScatterChart = withNoopInstall(ScatterChart)
export const ChartUtils = Utils

export type BChartInstance = InstanceType<typeof Chart>
export type BBarChartInstance = InstanceType<typeof BarChart>
export type BBubbleChartInstance = InstanceType<typeof BubbleChart>
export type BLinehartInstance = InstanceType<typeof LineChart>
export type BPieChartInstance = InstanceType<typeof PieChart>
export type BPolarAreaChartInstance = InstanceType<typeof PolarAreaChart>
export type BDonutChartInstance = InstanceType<typeof DonutChart>
export type BRadarChartInstance = InstanceType<typeof RadarChart>
export type BScatterChartInstance = InstanceType<typeof ScatterChart>
